import React from 'react';

/** Tag colour name — resolves to the global `.<color>-tag` ruleset in themes.css. */
export type StatusTagColor =
  | 'green'
  | 'black'
  | 'yellow'
  | 'red'
  | 'orange'
  | 'blue'
  | 'dark-blue'
  | 'dark-green'
  | 'light-black'
  | 'light-green'
  | 'pink'
  | 'sky-blue'
  | 'violet';

type Props = {
  label: string;
  color: StatusTagColor;
};

/**
 * Status tag — the Vue-ERP / design-system tag.
 *
 *   <span class="os-dt-tag-style os-dt-padding-4 green-tag">Active</span>
 *
 * Size / weight / padding come from the global `os-dt-tag-style` +
 * `os-dt-padding-4` rules (11.5px / 600 / line-height 12 / 4px padding); the
 * colour comes from the `.<color>-tag` ruleset (`--rw-tag-<color>-bg/fg`),
 * which flips per theme. No inline styles — colour is class-driven, matching
 * the orders `StatusBadge` and the "RW Vendors Redesign" `StatusTag`.
 */
export function StatusTag({ label, color }: Readonly<Props>): React.ReactElement {
  return <span className={`os-dt-tag-style os-dt-padding-4 ${color}-tag`}>{label}</span>;
}
